import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { switchMap, tap } from 'rxjs/operators';
import { LocalStorage_RefreshToken, LocalStorage_AuthToken, LocalStorage_ExpiresAt, LicenseManagerClientId } from '../constants/constants';
import { ConfigurationService } from './configuration.service';
import { AccessTokenResponse } from '../interfaces/auth.interfaces';

@Injectable({ providedIn: 'root', })
export class AccessCodeService {
    constructor(
        private httpClient: HttpClient,
        private configService: ConfigurationService,
    ) {
    }

    public refreshToken() {
        return this.configService.getAppConfig()
            .pipe(
                switchMap(cfg => {
                    var refreshToken = localStorage.getItem(LocalStorage_RefreshToken);
                    var payload = {
                        'grant_type': 'refresh_token',
                        'client_id': LicenseManagerClientId,
                        'refresh_token': refreshToken
                    };

                    // console.log('Calling refresh');
                    return this.postForm<AccessTokenResponse>(cfg.authProviderUrl + '/protocol/openid-connect/token', payload);
                }),
                tap(result => {
                    // console.log('Refreshed')
                    localStorage.setItem(LocalStorage_AuthToken, result.access_token);
                    localStorage.setItem(LocalStorage_RefreshToken, result.refresh_token);
                    localStorage.setItem(LocalStorage_ExpiresAt, (Date.now() + result.expires_in).toString());
                })
            );
    }

    public convertCode(code: string, sessionState: string, redirectUri: string) {
        const body = {
            grant_type: 'authorization_code',
            client_id: LicenseManagerClientId,
            code,
            sessionState,
            redirect_uri: redirectUri
        };

        return this.configService.getAppConfig()
            .pipe(
                switchMap(cfg => this.postForm<AccessTokenResponse>(`${cfg.authProviderUrl}/protocol/openid-connect/token`, body)),
                tap(result => {
                    if (result.access_token) {
                        localStorage.setItem(LocalStorage_AuthToken, result.access_token);
                        localStorage.setItem(LocalStorage_RefreshToken, result.refresh_token);
                        localStorage.setItem(LocalStorage_ExpiresAt, (Date.now() + result.expires_in).toString());
                    }
                })
            );
    }

    private postForm<T>(url: string, payload: Record<string, string>) {
        const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');
        let body = new URLSearchParams(payload);

        return this.httpClient.post<T>(url, body.toString(), { headers })
    }

}
